
export default {
  components: {
    VideoPlayer: () => import('~/components/Modules/Common/VideoPlayer'),
  },
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      playerReady: false,
      playing: false,
    }
  },
  methods: {
    onLoad() {
      // set classes for iframe
      this.$refs.player.$el
        .querySelector('iframe')
        .classList.add(
          'rounded-xl',
          'absolute',
          'w-full',
          'h-full',
          'top-0',
          'left-0'
        )

      this.playerReady = true
    },
    playingVideo() {
      this.playing = true
    },
  },
}
